import { stdObject } from "../../../data/types/stdObject";
import { RootState } from "../../../store/store";
import {
  deletePersonItemData,
  updateItemData,
} from "../../../store/updateData";
import { reorderItem } from "../../Login/functions/reorderItem";

export const updateInternalItem = (
  jsonData: stdObject,
  type: string,
  dispatch: any,
) => {
  delete jsonData.data[`COD${type}`];

  jsonData.data = reorderItem(jsonData.code, jsonData.data, jsonData);

  if (jsonData.codeUpdated) {
    dispatch(
      deletePersonItemData({
        type: "art",
        code: jsonData.codeUpdated,
      }),
    );
  }

  dispatch(
    updateItemData({
      type: type.toLowerCase() as keyof RootState["data"],
      data: {
        [jsonData.code]: {
          ...jsonData.data,
        },
      },
    }),
  );
  return jsonData;
};
